import { render } from "./EssaySubmission.vue?vue&type=template&id=0a77fe1e&scoped=true"
import script from "./EssaySubmission.vue?vue&type=script&lang=js"
export * from "./EssaySubmission.vue?vue&type=script&lang=js"

import "./EssaySubmission.vue?vue&type=style&index=0&id=0a77fe1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a77fe1e"]])

export default __exports__